export enum EMeasurementSystem {
  METRIC = 0,
  IMPERIAL = 1,
}
